import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import { ICodename } from "commons/interfaces";
import { AllGroupCodeName } from "constants/enum";

export interface IDataAlert {
    message: string;
    type: "warning" | "success" | "error" | "info";
}

export interface CommonState {
    loading: boolean,
    dataAlert: IDataAlert;
    loadingDataTable: boolean,
    codenames?: { [K in AllGroupCodeName]: ICodename[] },
}

const initialState: CommonState = {
    loading: false,
    codenames: undefined,
    dataAlert: { message: "", type: "info" },
    loadingDataTable: false,
}

export const commonSlice = createSlice({
    name: "common",
    initialState,
    reducers: {
        showLoading: (state, action: PayloadAction<any>) => {
            state.loading = action.payload
        },
        showLoadingDataTable: (state, action: PayloadAction<any>) => {
            state.loadingDataTable = action.payload
        },
        setDataAlert: (state, action: PayloadAction<IDataAlert>) => {
            state.dataAlert = action.payload;
        },
        resetDataAlert: (state) => {
            state.dataAlert = { message: "", type: "info" };
        },

        setGroupCodeNames: (state, action: PayloadAction<{ [K in AllGroupCodeName]: ICodename[] }>) => {
            state.codenames = action.payload
        },
    }
})

// Action creators are generated for each case reducer function
export const {
    showLoading,
    setGroupCodeNames,
    showLoadingDataTable,
    setDataAlert, resetDataAlert,
} = commonSlice.actions

export default commonSlice.reducer